import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { get, getOr } from 'lodash/fp';
import { Button, Loader, Icon } from 'rsuite';
import { fetchBlob } from '../../../services/fbm-api/api-request';
import { formatDateRange } from '../../../helpers/dates';
import triggerBlobDownload from '../../../helpers/triggerBlobDownload';
import * as TYPES from '../../../constants/inventory/InventoryExportTypes';

export const exportTypes = [
  TYPES.EXPORT_ITEMS,
  TYPES.EXPORT_PACKAGES,
  TYPES.EXPORT_ITEMS_AVAILABILITY,
  TYPES.EXPORT_PACKAGES_AVAILABILITY,
  TYPES.EXPORT_ITEMS_LOGS,
  TYPES.EXPORT_LOCATIONS,
  TYPES.EXPORT_TAGS
];

const ExportCsvButton = ({
  isFetching,
  onExport,
  exportUrl,
  type,
  searchQuery,
  ...restProps
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    setIsLoading(true);
    const createdAt = get('createdAt', searchQuery);
    const qs = createdAt
      ? { ...searchQuery, createdAt: formatDateRange(createdAt) }
      : searchQuery;
    try {
      const blob = await fetchBlob(`inventory/exports/${type}`, { qs });
      const dateTime = moment().format('MM-DD-YYYY');
      const filename = `inventory-${type}-${dateTime}.csv`;
      triggerBlobDownload(blob, filename);
    } catch (err) {
      toastr.error('Error', getOr('Server error', 'message', err));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button {...restProps} disabled={isFetching} onClick={handleExport}>
      {isFetching || isLoading ? (
        <Loader />
      ) : (
        <Fragment>
          <Icon icon="export" /> Export
        </Fragment>
      )}
    </Button>
  );
};

ExportCsvButton.propTypes = {
  type: PropTypes.oneOf(exportTypes).isRequired,
  isFetching: PropTypes.bool.isRequired,
  onExport: PropTypes.func.isRequired,
  exportUrl: PropTypes.string.isRequired,
  searchQuery: PropTypes.shape({}).isRequired
};

export default ExportCsvButton;
